import { useTranslation } from 'react-i18next'

import { Badge, Flex, Icon, Loader, Tooltip, Typography } from '@percent/lemonade'
import { ErrorView } from '@percent/admin-dashboard/common/components'

type ConfigRowProps = {
  id: string
  label: string
  tooltip?: string
  isLoading: boolean
  error?: string
  children?: React.ReactNode
}

export function ConfigRow({ id, label, tooltip, isLoading, error, children }: ConfigRowProps) {
  const { t } = useTranslation()

  const labelContent = (
    <Flex align="center" gap={1}>
      <Typography variant="default">{label}</Typography>
      {tooltip && (
        <Tooltip content={tooltip} placement="right">
          <span>
            <Icon name="info" size={4} color="gray500" />
          </span>
        </Tooltip>
      )}
    </Flex>
  )

  if (isLoading) {
    return (
      <Flex data-testid={id} justify="space-between" align="center" py={2}>
        {labelContent}
        <Loader />
      </Flex>
    )
  }

  if (error) {
    return (
      <Flex data-testid={id} justify="space-between" align="center" py={2}>
        {labelContent}
        <ErrorView errorMessage={error} />
      </Flex>
    )
  }

  return (
    <Flex data-testid={id} justify="space-between" align="center" py={2}>
      {labelContent}
      {children ?? <Badge variant="default">{t('typography.notConfigured')}</Badge>}
    </Flex>
  )
}
